import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'ar',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
    },
  });

// Set initial RTL based on current language
const currentLang = i18n.language || 'ar';
if (typeof document !== 'undefined') {
  document.documentElement.dir = currentLang.startsWith('ar') ? 'rtl' : 'ltr';
  document.documentElement.lang = currentLang;
}

export default i18n;